import MenuItemFilterSection from "@/custom-types/MenuItemFilterSection";

const DEALS_UI_FILTER_KEY = "On sale";

const PRICE_RANGE_BUCKETS = {
  ABOVE_TWO_HUNDRED: "$200 and above",
  FIFTY_TO_HUNDRED: "$50 to $100",
  HUNDRED_TO_TWO_HUNDRED: "$100 to $200",
  TWENTYFIVE_TO_FIFTY: "$25 to $50",
  UNDER25: "Under $25",
};

const PRICE_SEARCH_RANGES: {
  [key: string]: { min?: number; max?: number };
} = {
  [PRICE_RANGE_BUCKETS.UNDER25]: { max: 25 },
  [PRICE_RANGE_BUCKETS.TWENTYFIVE_TO_FIFTY]: { max: 50, min: 25 },
  [PRICE_RANGE_BUCKETS.FIFTY_TO_HUNDRED]: { max: 100, min: 50 },
  [PRICE_RANGE_BUCKETS.HUNDRED_TO_TWO_HUNDRED]: { max: 200, min: 100 },
  [PRICE_RANGE_BUCKETS.ABOVE_TWO_HUNDRED]: { min: 200 },
};

const THC_RANGE_BUCKETS = {
  HIGH: "THC:High",
  LOW: "THC:Low",
  MEDIUM: "THC:Medium",
  NONE: "THC:None",
};

const THC_SEARCH_RANGES: {
  [key: string]: { min?: number; max?: number };
} = {
  [THC_RANGE_BUCKETS.NONE]: { max: 0 },
  [THC_RANGE_BUCKETS.LOW]: { max: 10, min: 1 },
  [THC_RANGE_BUCKETS.MEDIUM]: { max: 20, min: 10 },
  [THC_RANGE_BUCKETS.HIGH]: { min: 20 },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
const createPriceFilter = (filters: any, filterKey: string) =>
  filters[filterKey].reduce(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
    (priceRangeFilters: any, filterValue: string, index: number) => {
      const { min, max } = PRICE_SEARCH_RANGES[filterValue];
      return {
        ...priceRangeFilters,
        [`filter[price][${index}][gte]`]: min,
        [`filter[price][${index}][lte]`]: max,
      };
    },
    {},
  );

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
const createTHCFilter = (filters: any, filterKey: string) =>
  filters[filterKey].reduce(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
    (thcRangeFilters: any, filterValue: string, index: number) => {
      const { min, max } = THC_SEARCH_RANGES[filterValue];
      return {
        ...thcRangeFilters,
        [`filter[thc][${index}][gte]`]: min,
        [`filter[thc][${index}][lte]`]: max,
      };
    },
    {},
  );

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
export const mapFilterObjectToAPI = (filters?: any) =>
  Object.keys(filters).reduce((filterObj, filterKey) => {
    // * Price filters require special transformation to this form:
    // * "filter[price][0][gte]=0&filter[price][0][lte]=10"
    if (
      filterKey === MenuItemFilterSection.PriceRange &&
      Array.isArray(filters[filterKey])
    ) {
      return {
        ...filterObj,
        ...createPriceFilter(filters, filterKey),
      };
    }
    // * End special logic for Price Range Filtering

    // * THC filters require special transformation to this form:
    // * "filter[thc][0][gte]=0&filter[thc][0][lte]=10"
    if (
      filterKey === MenuItemFilterSection.THCLevel &&
      Array.isArray(filters[filterKey])
    ) {
      return {
        ...filterObj,
        ...createTHCFilter(filters, filterKey),
      };
    }
    // * End special logic for THC Range Filtering

    // * Change Deals filter key
    if (filterKey === DEALS_UI_FILTER_KEY) {
      return {
        ...filterObj,
        [`filter[${MenuItemFilterSection.Deals}]`]: "true",
      };
    }
    // *

    // * All other filters can be applied as-is
    return {
      ...filterObj,
      [`filter[${filterKey}]`]: filters[filterKey],
    };
  }, {});

// * Used for MenuFilters, we no longer need to format price/thc with lgt/gte separate filters.
// * Api expects the filter value to be the same as it was returned.
export const mapFilterObjectToAPIV2 = (filters: {
  [key: string]: string | boolean | number;
}) =>
  Object.keys(filters).reduce((filterObj, filterKey) => {
    if (filterKey === DEALS_UI_FILTER_KEY) {
      return {
        ...filterObj,
        [`filter[${MenuItemFilterSection.Deals}]`]: "true",
      };
    }
    return {
      ...filterObj,
      [`filter[${filterKey}]`]: filters[filterKey],
    };
  }, {});
